var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendBgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 488,
    viewBox: "0 0 375 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.285 97.3249C360.285 164.724 179.368 361.504 88.5152 231.049C29.7174 146.621 -107.969 153.442 -107.969 86.0434C-107.969 18.6447 43.5326 -24.7112 156.23 -24.7112C268.927 -24.7112 360.285 29.9262 360.285 97.3249Z",
    fill: "#802D59"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.332 6.3637C148.332 73.7624 408.772 99.4299 296.076 99.4299C183.379 99.4299 -218 155.603 -218 88.204C-218 20.8053 -168.421 -115.672 -55.7241 -115.672C56.9728 -115.672 148.332 -61.035 148.332 6.3637Z",
    fill: "#9F536E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422 27.9483C422 113.615 244.716 215.428 132.069 215.428C19.4219 215.428 169.133 150.173 169.133 64.5072C169.133 -21.1591 68.7491 -163 181.396 -163C294.043 -163 422 -57.718 422 27.9483Z",
    fill: "#FFB389"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_35",
    x: -320.522,
    y: -237.265,
    width: 893.362,
    height: 724.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 106.277,
    result: "effect1_foregroundBlur_0_35"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_35",
    x: -430.554,
    y: -328.226,
    width: 967.469,
    height: 662.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 106.277,
    result: "effect1_foregroundBlur_0_35"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_35",
    x: -122.467,
    y: -375.554,
    width: 757.021,
    height: 803.536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 106.277,
    result: "effect1_foregroundBlur_0_35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBgSmall);
export default __webpack_public_path__ + "static/media/send-bg-small.0fcceaaea11819f4c9f5ffdf36a59d3b.svg";
export { ForwardRef as ReactComponent };